import { useMemo } from 'react'

import type { PERMISSIONS } from '.'

import { useSessionStore } from 'store/session'

type UseAuthorizeProps = {
  permissions: PERMISSIONS | PERMISSIONS[]
}

export function useAuthorize({ permissions }: UseAuthorizeProps) {
  const { user, status } = useSessionStore()

  return useMemo(() => {
    const newPermissions: PERMISSIONS[] = Array.isArray(permissions)
      ? permissions
      : [permissions]

    if (status === 'authenticated') {
      const hasPermission = newPermissions.some((permission) =>
        user.permissions.includes(permission)
      )

      return hasPermission
    }

    return false
  }, [status, user.permissions, permissions])
}
